import React from 'react';
import TextField from 'mrf/view/TextField';
import FormCRUD from 'mrf/view/FormCRUD';
import { useFormSelector } from 'mrf/redux/ReduxHelper';
import { Grid, Col } from 'mrf/view/Grid';
import { useDispatch } from 'react-redux';
import { updateSystemParameterDataAction } from 'mrf/redux/actions/systemParameters';

export default function ParameterForm({ history, match }) {
    const context = useFormSelector({
        id: match.params.id,
        resource: 'systemParameters',
    });

    const dispatch = useDispatch();

    const triggerUpdate = (data) => {
        const { code, value } = data;
        dispatch(updateSystemParameterDataAction(code, value))
    };

    return (
        <FormCRUD
            title='System Parameter'
            match={match}
            history={history}
            context={context}
            hideDelete
            actionAfterSave={triggerUpdate}
        >
            <Grid gap={3}>
                <Col size={4}>
                    <TextField
                        label='Code'
                        field='code'
                        required
                    />
                </Col>
                <Col size={4}>
                    <TextField
                        label='Name'
                        field='name'
                        required
                    />
                </Col>
                <Col size={4}>
                    <TextField
                        label='Value'
                        field='value'
                    />
                </Col>
            </Grid>
        </FormCRUD>
    );
}